import { useNavigate, useParams } from "react-router-dom";
import { Presence } from "@/components/Presence";

const COPY = {
  maintenance: {
    eyebrow: "resting",
    title: "Griot is resting.",
    body: "The curators are tending the archive. Come back in a little while and I'll be here, listening.",
  },
  closed: {
    eyebrow: "closed",
    title: "This Lab has closed its doors.",
    body: "Everything it remembers is safe — it simply isn't taking visitors. Try another Lab, or return when it reopens.",
  },
  capped: {
    eyebrow: "enough for today",
    title: "I've spoken my fill for today.",
    body: "Conversations pause when the day's budget is spent, so this work can keep going. Come back tomorrow and we'll pick it up.",
  },
  offline: {
    eyebrow: "out of reach",
    title: "I can't hear you from here.",
    body: "Your connection dropped somewhere between us. Check it, and try once more.",
  },
};

export default function Fallback() {
  const { kind } = useParams();
  const nav = useNavigate();
  const c = COPY[kind] || COPY.maintenance;

  return (
    <div
      className="grain lamp relative flex min-h-screen flex-col justify-center overflow-hidden px-6 lg:px-20"
      style={{ "--lab-accent": "#C87D55", background: "var(--bg-primary)" }}
      data-testid={`fallback-${kind}`}
    >
      <div className="pointer-events-none absolute inset-x-0 top-1/2 z-0 -translate-y-1/2 opacity-40">
        <Presence state="idle" accent="#C87D55" height={420} />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-xl">
        <div className="flex items-start gap-5">
          <span className="mt-1 h-12 w-[2px] shrink-0 rounded-full" style={{ background: "linear-gradient(180deg, transparent, #C87D55, transparent)" }} />
          <div>
            <p className="eyebrow rise">{c.eyebrow}</p>
            <h1 className="rise rise-1 mt-4 font-display text-[36px] font-light leading-[1.1] tracking-tight sm:text-[44px]">{c.title}</h1>
            <p className="rise rise-2 mt-5 max-w-[28rem] text-[14px] leading-[1.9]" style={{ color: "var(--text-dim)" }}>{c.body}</p>
            <button
              data-testid="fallback-back-btn"
              onClick={() => nav("/")}
              className="rise rise-3 mt-10 rounded-full border px-7 py-3 font-mono text-[10px] uppercase tracking-[0.24em] transition-colors hover:text-[#F4EFE6]"
              style={{ borderColor: "var(--border-linen)", color: "var(--text-dim)" }}
            >
              back to the Labs
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
